var map = {
	"./year2016.json": 338,
	"./year2017.json": 9450,
	"./year2018.json": 9556,
	"./year2019.json": 4951,
	"./year2020.json": 3319,
	"./year2021.json": 1364,
	"./year2022.json": 1310,
	"./year2023.json": 1126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8005;